'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultStyles = undefined;

var _templateObject = _taggedTemplateLiteral([''], ['']);

exports.FormsComponent = FormsComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bduiStyles = require('@bd/bdui-styles');

var _bduiStyles2 = _interopRequireDefault(_bduiStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var defaultStyles = exports.defaultStyles = (0, _bduiStyles.css)(_templateObject);

function FormsComponent(_ref) {
  var className = _ref.className;

  return _react2.default.createElement(
    'div',
    { className: '' + className },
    _react2.default.createElement(
      'div',
      { className: 'Forms_wrapper' },
      _react2.default.createElement(
        'div',
        { className: 'Forms_inner' },
        'Very Simple Component'
      )
    )
  );
}

FormsComponent.propTypes = {
  className: _propTypes2.default.string
};

FormsComponent.defaultProps = {
  className: ''
};

exports.default = (0, _bduiStyles2.default)(defaultStyles)(FormsComponent);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-forms/build/Forms.js
// module id = 1195
// module chunks = 0